<template>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="description" content="">
    <meta name="author" content="Sylva Foundation">
    <meta name="generator" content="Hugo 0.84.0">
    <title>Forestry and Climate Change Partnership</title>


    <link rel="canonical" href="https://getbootstrap.com/docs/5.0/examples/carousel/">

    
    <!-- Custom styles for this template -->
  </head>
  <body>

  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->

  <div class="container marketing">
    <div class="row mb-3">
      <div class="col-lg">
        <h4>
          The <span class="greeni">Forestry and Climate Change Partnership (FCCP)</span> exists to help Britain's trees, woods, and forests to be resilient and adapt to a changing climate.
        </h4>
      </div>
      <div class="col-lg">
        <p>
        The FCCP promotes measures which enhance the adaptation of trees, woods and forests to climate change and associated impacts. It adopts the latest evidence and draws upon the experience of its partnership members. At a time when evidence may be insufficient or contrary, the partnership has a particularly important role in presenting a balanced view and identifying potential risks associated with taking or not taking practical action.
        </p>
      </div>
    </div>

    <hr class="featurette-divider">
      <div class="row">
        <div class="col-7">
          <h4 class="greeni mb-3">
            Latest news and activities
          </h4>
          <latest-news></latest-news>
        </div>
        <div class="col-1">
        </div>
        <div class="col-4 twitterembed">
          <twitter-feed></twitter-feed>
        </div>
      </div>
  </div>
      
  </body>
</html>
</template>

<script>
import LatestNews from './LatestNews.vue'
import TwitterFeed from './TwitterFeed.vue'

export default {
  components: { TwitterFeed, LatestNews },
  name: 'Home',
  props: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }

      @media (min-width: 768px) {
        .bd-placeholder-img-lg {
          font-size: 3.5rem;
        }
      }
</style>
